import { render, staticRenderFns } from "./CommentPraiseInfo.vue?vue&type=template&id=e33177ac&scoped=true&"
import script from "./CommentPraiseInfo.vue?vue&type=script&lang=js&"
export * from "./CommentPraiseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommentPraiseInfo.vue?vue&type=style&index=0&id=e33177ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33177ac",
  null
  
)

export default component.exports